import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import SearchPage from "@/pages/Search";
import DockDetails from "@/pages/DockDetails";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ListDock from "@/pages/ListDock";
import Dashboard from "@/pages/Dashboard";
import CheckoutReturn from "@/pages/CheckoutReturn";
import AuthCallback from "@/pages/AuthCallback";
import Messages from "@/pages/Messages";
import Partners from "@/pages/Partners";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback synchronously (before any /me check)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/docks/:id" element={<DockDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/list" element={<ListDock />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/checkout/return" element={<CheckoutReturn />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
